import { render } from "./BacklogView.vue?vue&type=template&id=4f3b30c8"
import script from "./BacklogView.vue?vue&type=script&lang=js"
export * from "./BacklogView.vue?vue&type=script&lang=js"

import "./BacklogView.vue?vue&type=style&index=0&id=4f3b30c8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/view/BacklogView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f3b30c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f3b30c8', __exports__)) {
    api.reload('4f3b30c8', __exports__)
  }
  
  module.hot.accept("./BacklogView.vue?vue&type=template&id=4f3b30c8", () => {
    api.rerender('4f3b30c8', render)
  })

}


export default __exports__